import * as types from '../mutation-types'
import { api } from '@/modules/api'
import { pathOr } from 'ramda'

const state = {
  promoCodes: [],
  totalPromoCodesPages: 0,
  totalPromoCodesItems: 0
}

const getters = {
  promoCodesList: state => state.promoCodes,
  totalPromoCodesPages: state => state.totalPromoCodesPages,
  totalPromoCodesItems: state => state.totalPromoCodesItems,
  getPromoCodeSetting: state => state.promoCodeSetting
}

const actions = {
  async getPromoCodesList ({commit}, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.promoCodes.getPromoCodesList(payload))
      commit(types.SET_PROMO_CODES_LIST, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, `Promo codes wasn't uploaded`)
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async addPromoCode ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.promoCodes.addPromoCode(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Promo codes was added successfully')
    } catch (err) {
      //  if (err.response.data.Code === 'validation.base-0001') {
      if (pathOr('', ['response', 'data', 'Code'], err) === 'validation.base-0001') {
        commit(types.CREATE_ERROR_MESSAGE, 'Promo codes weren\'t added.' + ' ' + pathOr('', ['response', 'data', 'ValidationFailures', '0', 'errorMessage'], err))
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Promo codes weren\'t added')
      }
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editPromoCode ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.promoCodes.editPromoCode(), payload)
      // await this.dispatch('getPromoCodesList')
      commit(types.CREATE_SUCCESS_MESSAGE, 'Promo codes was edited successfully')
    } catch (err) {
      if (err.response.data.Code === 'fm.cms-0040') {
        commit(types.CREATE_ERROR_MESSAGE, 'Promo code usages count must be greater then count of attendees that already use it')
      } else if (pathOr('', ['response', 'data', 'Code'], err) === 'validation.base-0001') {
        commit(types.CREATE_ERROR_MESSAGE, 'Promo codes weren\'t edited.' + ' ' + pathOr('', ['response', 'data', 'ValidationFailures', '0', 'errorMessage'], err))
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Promo codes weren\'t edited')
      }
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updatePromoCodeSettings ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.promoCodes.updateSettings(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Settings were updated successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Settings weren\'t updated')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_PROMO_CODES_LIST] (state, { promoCodes, totalPages, totalItems }) {
    state.promoCodes = [...promoCodes]
    state.totalPromoCodesPages = totalPages
    state.totalPromoCodesItems = totalItems
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/promoCodes.js